import React from "react";
import { gettext } from "../shared/utils/legacy";
import useCachedUrlData from "../shared/hooks/useCachedUrlData";
import { getIconClass } from "./utils";

type ProductStatus = {
  // eslint-disable-next-line
  status_per_cropfield: any;
  // eslint-disable-next-line
  status_overview: any;
  // ...
};
const AdmissionStatus = () => {
  const { data, error } = useCachedUrlData<any>("/api/v3/admissions/summary/");
  if (error) console.error(error);
  // TODO use WrapErrorLoading
  if (!data) {
    return (
      <div>
        <i className="fas fa-tire-rugged fa-spin" /> {gettext("Loading")}...
      </div>
    );
  }
  const admissionWarningCount = data.warningCount;
  const admissionStatusBoolean = admissionWarningCount === 0;
  return (
    <a
      href="/apps/admissions/"
      className="js-log-metric text-black"
      data-metrics_category="summary_widget"
      data-metrics_sub_category="admission_overview"
      title={gettext("Go to admission overview")}
    >
      <i className={getIconClass(admissionStatusBoolean)} />
      &nbsp;{admissionWarningCount}&nbsp;
      {admissionWarningCount === 1 ? gettext("warning") : gettext("warnings")}
    </a>
  );
};
export default AdmissionStatus;
